import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIHoverActionController} from './UIHoverActionController'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorCity} from '@colonist/game-mechanic-validators'
import {MechanicCityState} from '@colonist/game-states'

export class UICityHoverActionController extends UIHoverActionController {
    private readonly cityValidator: MechanicValidatorCity

    constructor(uiGameManager: UIGameManager, cityState: MechanicCityState) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.City)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildCitySkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)
        this.cityValidator = new MechanicValidatorCity(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, cityState)
    }

    getBankActionAmount(index: number): number {
        const cityPlayerState = this.cityValidator.getCityPlayerState(this.uiGameManager.gameController.myColor)
        return cityPlayerState.bankCityAmount
    }

    protected updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor)
        const canPlaceCity = this.cityValidator.canPlayerPlaceCity(player.color)
        this.updateHoverLocations(canPlaceCity.validHoverLocations, canPlaceCity.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getCityForPlayer(this.uiGameManager.gameController.myColor)
    }
}
